
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ResetPasswordDialog } from "@/components/admin/contact/ResetPasswordDialog";
import { formatPhoneNumber } from "@/utils/format";

interface PersonalInfoFieldsProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password?: string;
  onFieldChange: (field: string, value: string) => void;
  isNewEmployee: boolean;
}

export const PersonalInfoFields = ({
  firstName,
  lastName,
  email,
  phone,
  password,
  onFieldChange,
  isNewEmployee
}: PersonalInfoFieldsProps) => {
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("Phone input changed to:", e.target.value);
    onFieldChange('phone', e.target.value);
  };
  
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="firstName">First Name</Label>
        <Input
          id="firstName"
          value={firstName}
          onChange={(e) => onFieldChange('first_name', e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="lastName">Last Name</Label>
        <Input
          id="lastName"
          value={lastName}
          onChange={(e) => onFieldChange('last_name', e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => onFieldChange('email', e.target.value)}
          disabled={!isNewEmployee}
        />
      </div>
      {isNewEmployee ? (
        <div className="space-y-2">
          <Label htmlFor="password">Initial Password</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => onFieldChange('password', e.target.value)}
            placeholder="Enter initial password"
          />
        </div>
      ) : (
        <div className="flex justify-start">
          <ResetPasswordDialog 
            userId={email} // Use email as identifier since we're on the edit form
            userEmail={email}
          />
        </div>
      )}
      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input
          id="phone"
          name="phone"
          type="tel"
          value={phone || ""} // Ensure we don't pass undefined
          onChange={handlePhoneChange}
          placeholder="Enter phone number"
        />
      </div>
    </div>
  );
};
